import type { ComponentSection } from './types';

export const componentSections: ComponentSection[] = [
    {
        rows: [{ detail: '54 cycles · 51.8V', label: 'Pack A', status: 'DUE' }],
        titleKey: 'batteryPacks'
    },
    {
        rows: [
            { detail: 'Self-test 2d ago', label: 'Front', status: 'OK' },
            { detail: 'Self-test 2d ago', label: 'Back', status: 'DUE' },
            { detail: 'Self-test 2d ago', label: 'Downward (terrain)', status: 'OK' }
        ],
        titleKey: 'radars'
    },
    {
        rows: [
            { label: 'FC', status: 'COMPLIANT' },
            { label: 'Pump seal kit', status: 'OUTDATED' },
            { label: 'ESC', status: 'NOT_REPORTED' },
            { label: 'Battery', status: 'NOT_REPORTED' }
        ],
        titleKey: 'firmware'
    }
];
